import React, { useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { TableContext } from '../../contexts/tableContext';
import { PERMISSION_DENIED_EVENT } from '../../utils/permissionRedirect';
import {
  getDefaultAdminHomePath,
  isPathAllowedForUser,
} from '../../utils/menuAccess';
import PermissionDeniedModal from '../../pages/permission/PermissionDeniedModal';

function PermissionDeniedGate() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setPermissionDeniedOpen, userMenus } = useContext(TableContext);

  useEffect(() => {
    const handler = () => {
      toast.dismiss();

      const home = getDefaultAdminHomePath(userMenus);
      if (!isPathAllowedForUser(location.pathname, userMenus)) {
        navigate(home, { replace: true });
      }

      setPermissionDeniedOpen(true);
    };

    window.addEventListener(PERMISSION_DENIED_EVENT, handler);
    return () => window.removeEventListener(PERMISSION_DENIED_EVENT, handler);
  }, [location.pathname, userMenus, navigate, setPermissionDeniedOpen]);

  return <PermissionDeniedModal />;
}

export default PermissionDeniedGate;
